export default "__VITE_ASSET__EHhAz4KR__"